import { Grid, Typography } from '@material-ui/core'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Links from '@material-ui/core/Link'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import { TFunction } from 'i18next'
import * as moment from 'moment'
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import {
  generateTrackingLink,
  getBrands,
  getBrandsLogosURLSrc,
} from '../../../utils/brandsHelper'
import { isUserAuthenticated } from '../../../utils/isUserAuthenticated'
import { setItemToLocalStorage } from '../../../utils/setLocalStorage'
import { trendingBrandsLogos } from '../../../utils/trendingBrandsLogos'
import { useAppState } from '../../appState'
import birdIcon from '../../assets/images/chirpyest-logo.svg'
import joinCircle1 from '../../assets/images/newJoin-1.jpg'
import joinCircle2 from '../../assets/images/newJoin-2.png'
import joinCircle3 from '../../assets/images/newJoin-3.jpg'
import CHRArrowButton from '../../components/arrowButton'
import BrandItem from '../../components/newBrandItem'
import BrandCardsList from '../../components/newBrandsList'
import { FONTS, ROUTES, thirdPartyRefKeys } from '../../constants'
import useBrandJoinFlow from '../../hooks/useBrandJoinFlow'
import Layout from '../../layouts/defaultLayout'
import OldJoin from '../../pages/joins'
import { styles } from '../../pagesStyles/joinaStyles'
import BlockUserInterface from '../blockUserInterface'
import BrandItemUser from '../brandItemUser'
import BrandsListComponent from '../brandsListCopy'
import CHRButton from '../button'
import CHRContentContainer from '../contentContainer'
import JoinCircle from '../joinCircle'
import DetailsModal from '../joinModales/details'
import JoinWithEmailModal from '../joinModales/joinWithEmail'
import MainModal from '../joinModales/mainJoin'
import CHROutlinedButton from '../outlinedButton'
import PinExtensionReminderPopOut from '../popOuts/pinExtensionReminderPopOut'
import SEO from '../seo'
import SignInModal from './../signInModal'
interface JoinProps {
  t: TFunction
  data: any
}

const referralIdRegex = /(.*-.*)/

const Joins = ({ t, data }: JoinProps) => {
  const classes = styles()
  const [appState] = useAppState()
  const [modalOpened, setModalOpened] = useState(
    window.location.search.includes('popup=1') ? 1 : 0
  )
  const { pathname, state = {} } = useLocation()

  const joinSourceUrl = state?.joinSourceUrl
  const referralId = pathname?.split('/')[2]?.split('#')[0] || ''
  const [param] = window.location.search.slice(1).split('&')
  const [isExtensionDownloaded, setIsExtensionDownloaded] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [isTermsChecked, setIsTermsChecked] = useState(true)
  const [isNewsletterChecked, setIsNewsletterChecked] = useState(true)
  const [isOpenSignInModal, setIsOpenSignInModal] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [landingBrands, setLandingBrands] = useState([])
  const [homeProducts, setHomeProducts] = useState([])
  const [topProducts, setTopProducts] = useState([])
  const [start, setStart] = useState(0)
  const [end, setEnd] = useState(0)

  const { clearJoinFlowStorage } = useBrandJoinFlow()

  const deviceType = () => {
    const ua = navigator.userAgent
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet'
    } else if (
      /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return 'mobile'
    }
    return 'desktop'
  }

  function getElements(arr, s, e) {
    const arrNew = []
    for (let i = s; i <= e; i++) {
      let index = i
      if (i < 0) {
        index = arr.length + i
      }
      arrNew.push(arr[index])
    }
    return arrNew
  }

  const forwardArrowClicked = () => {
    let startIndex = start + 4
    let endIndex
    if (startIndex === topProducts.length - 1) {
      startIndex = -1
    } else if (startIndex > topProducts.length - 1) {
      startIndex = startIndex - topProducts.length - 1
    }
    startIndex = startIndex % topProducts.length
    endIndex = startIndex + 5
    if (endIndex > topProducts.length - 1) {
      endIndex = endIndex - topProducts.length
      startIndex = endIndex - 5
    }
    setHomeProducts(getElements(topProducts, startIndex, endIndex))
    setStart(startIndex)
    setEnd(endIndex)
  }

  const backArrowClicked = () => {
    let startIndex = start - 4
    startIndex = startIndex % topProducts.length
    const endIndex = startIndex + 5
    setHomeProducts(getElements(topProducts, startIndex, endIndex))
    setStart(startIndex)
    setEnd(endIndex)
  }

  useEffect(() => {
    if (joinSourceUrl) {
      setItemToLocalStorage('joinSourceUrl', joinSourceUrl)
    } else {
      localStorage.removeItem('joinSourceUrl')
    }
  }, [])

  useEffect(() => {
    getBrands()
      .then(response => {
        let filteredBrands = response.data.data.filter(
          (item: any) => item.isTrending
        )
        const filteredTrendingBrands = getBrandsLogosURLSrc(
          filteredBrands,
          trendingBrandsLogos
        )
        const limitedBrands = filteredTrendingBrands.slice(0, 16)
        setTopProducts(filteredTrendingBrands)
        setHomeProducts(limitedBrands)
        setLandingBrands(limitedBrands)
      })
      .catch(() => setLandingBrands([]))
  }, [])

  useEffect(() => {
    if (referralId) {
      setItemToLocalStorage(
        'referralId',
        JSON.stringify({ id: referralId, time: moment().format() })
      )
    }

    if (
      param.split('=')[0] === 'fromExtension' &&
      param.split('=')[1] === 'true'
    ) {
      setItemToLocalStorage('extensionDownloaded', 'true')
      isUserAuthenticated().then(result => {
        if (!!result) {
          navigate(ROUTES.member, { state: { showPopUp: true } })
        } else {
          setIsModalOpen(true)
          setIsExtensionDownloaded(true)
          setIsPageLoading(false)
        }
      })
    } else {
      setIsPageLoading(false)
      const isExtensionInstalled = window.localStorage.getItem(
        'extensionDownloaded'
      )
      if (isExtensionInstalled && isExtensionInstalled === 'true') {
        setIsExtensionDownloaded(true)
      }
      return
    }
  }, [])

  const handleCloseModal = () => {
    setModalOpened(0)
    ;(modalOpened === 3 || modalOpened === 4) && navigate(ROUTES.member)
  }

  const nextStep = (updateThirdPartyReferral = false) => {
    if (updateThirdPartyReferral) {
      const currentReferral = JSON.parse(
        window.localStorage.getItem('referralId') ?? '{}'
      ) as { id: string; time: string }
      // This removes the information of other flows from referral
      if (
        currentReferral.id &&
        thirdPartyRefKeys.includes(String(currentReferral.id).toLowerCase())
      ) {
        window.localStorage.setItem(
          'referralId',
          JSON.stringify({
            id: currentReferral.id,
            time: new Date().toISOString(),
          })
        )
      }
    }

    setModalOpened((prevState: number) => prevState + 1)
  }

  const goToUserInfoPage = () => {
    navigate(ROUTES.personalInfo)
  }

  const handleNewslettersSwitch = () => {
    setIsNewsletterChecked(!isNewsletterChecked)
  }

  const handleTermsSwitch = () => {
    setIsTermsChecked(!isTermsChecked)
  }

  const closeSignInModal = () => {
    setIsOpenSignInModal(false)
  }

  const isInvite = referralId && referralIdRegex.test(referralId)
  if (isInvite) {
    return <OldJoin t={t} data={data} />
  }

  if (isPageLoading) {
    return <BlockUserInterface />
  }

  return (
    <>
      <Layout>
        <SEO
          title={t('join.metaTitle')}
          description={t('join.metaDescription')}
          keywords={t('join.keywords')}
        />
        <CHRContentContainer>
          <section className={classes.section}>
            <Breadcrumbs aria-label="breadcrumb">
              <Links
                color="inherit"
                rel="preconnect"
                onClick={(
                  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
                ) => {
                  event.preventDefault()
                  navigate(ROUTES.home)
                }}
              >
                home
              </Links>
              <Typography color="textPrimary">join chirpyest</Typography>
            </Breadcrumbs>
            <div>
              <Typography variant="h1" className={classes.TopTitle}>
                shop, share, earn cash back!
              </Typography>
              <CHRButton
                onClick={() => nextStep(true)}
                label="Join chirpyest - it's free"
                icon={birdIcon}
                customStyle={classes.buttonStyles}
              />
            </div>
            {deviceType() === 'mobile' && (
              <div>
                <BrandsListComponent>
                  {homeProducts.map((brand: any, index: number) => {
                    return (
                      <BrandItem
                        brandLogo={brand.src}
                        name={brand.brandName}
                        cashBack={brand.commission}
                        isCashbackShownInWebsite={
                          brand.isCashbackShownInWebsite
                        }
                        link={generateTrackingLink(
                          brand,
                          {
                            userId: appState.userId,
                            userName: appState.username,
                          },
                          '',
                          '',
                          Boolean(appState.userId)
                        )}
                        key={index}
                        isCardOnLanding
                      />
                    )
                  })}
                </BrandsListComponent>
              </div>
            )}
            {deviceType() === 'tablet' && (
              <div>
                <BrandsListComponent>
                  {homeProducts.map((brand: any, index: number) => {
                    return (
                      <BrandItem
                        brandLogo={brand.src}
                        name={brand.brandName}
                        cashBack={brand.commission}
                        isCashbackShownInWebsite={
                          brand.isCashbackShownInWebsite
                        }
                        link={generateTrackingLink(
                          brand,
                          {
                            userId: appState.userId,
                            userName: appState.username,
                          },
                          '',
                          '',
                          Boolean(appState.userId)
                        )}
                        key={index}
                        isCardOnLanding
                      />
                    )
                  })}
                </BrandsListComponent>
              </div>
            )}
            {deviceType() === 'desktop' && (
              <div className={classes.trendingContainer2}>
                <div className={classes.topProductsContainer}>
                  <div className={classes.arrowMaxHeight}>
                    <CHRArrowButton
                      isLeftArrow
                      label=""
                      onClick={backArrowClicked}
                      hoverEffects={true}
                    />
                  </div>

                  <Grid
                    container
                    spacing={3}
                    style={{ flexWrap: 'nowrap', overflow: 'hidden' }}
                  >
                    {homeProducts.map((brand: any, index: number) => (
                      <Grid
                        item
                        lg={2}
                        md={3}
                        sm={6}
                        xs={6}
                        key={brand.id}
                        style={{ minWidth: '229.5px' }}
                      >
                        <BrandItemUser
                          brandLogo={brand.src}
                          name={brand.brandName}
                          cashBack={brand.commission}
                          isCashbackShownInWebsite={
                            brand.isCashbackShownInWebsite
                          }
                          link={generateTrackingLink(
                            brand,
                            {
                              userId: appState.userId,
                              userName: appState.username,
                            },
                            '',
                            '',
                            Boolean(appState.userId)
                          )}
                          key={index}
                          isCardOnLanding
                        />
                      </Grid>
                    ))}
                  </Grid>
                  <div className={classes.arrowMaxHeight}>
                    <CHRArrowButton
                      label=""
                      onClick={forwardArrowClicked}
                      hoverEffects={true}
                    />
                  </div>
                </div>
                {/* <div className={classes.trendingContainer3}>
                  <div className={classes.CHRbArrowButton}>
                    <CHRArrowButton
                      label="see all brands"
                      onClick={() => navigate('/brands')}
                      hoverEffects={true}
                    />
                  </div>
                </div> */}
              </div>
            )}
            <div className={classes.firstRow} style={{ marginTop: '3rem' }}>
              <JoinCircle circlelabel="easy" color="#175972">
                shopping tools to help find cashback
              </JoinCircle>
              <JoinCircle
                circlelabel="share"
                color="#F27870"
                customStyle={classes.circle2}
              >
                finds with friends – earn more cash back
              </JoinCircle>
            </div>
            <div className={classes.secondRow}>
              <JoinCircle circlelabel="save" color="#F9BEBF">
                items to your board
              </JoinCircle>
              <JoinCircle
                circlelabel="earn"
                color="#2E7C86"
                customStyle={classes.circle4}
              >
                up to 15% cash back
              </JoinCircle>
              <JoinCircle circlelabel="shop" color="#E33D40">
                1,000’s of top brands
              </JoinCircle>
            </div>
          </section>
          <section className={classes.section}>
            <Typography variant="h1" className={classes.centerText}>
              what is chirpyest?
            </Typography>
            <Grid container spacing={5}>
              <Grid item md={4} className={classes.gridItem}>
                <img
                  src={joinCircle1}
                  alt="join-circle"
                  className={classes.joinCircle}
                />
                <Typography variant="h2">a shopping platform</Typography>
                <Typography variant="subtitle1">
                  a shopping platform where you can shop and earn cash back from
                  top retailers and brands.
                </Typography>
              </Grid>
              <Grid item md={4} className={classes.gridItem}>
                <img
                  src={joinCircle2}
                  alt="join-circle-2"
                  className={classes.joinCircle}
                />
                <Typography variant="h2">a browser extension</Typography>
                <Typography variant="subtitle1">
                  a browser extension that automatically scans the web for cash
                  back wherever you shop!
                </Typography>
              </Grid>
              <Grid item md={4} className={classes.gridItem}>
                <img
                  src={joinCircle3}
                  alt="join-circle-3"
                  className={classes.joinCircle}
                />
                <Typography variant="h2">your shopping board</Typography>
                <Typography variant="subtitle1">
                  your personal shopping board to save items you love to either
                  shop or share and earn cash back
                </Typography>
              </Grid>
              <CHRButton
                onClick={() => navigate(ROUTES.howItWorks)}
                label="learn how it works"
                customStyle={classes.howItWordsButton}
              />
            </Grid>
          </section>
        </CHRContentContainer>
        <div className={classes.flexOrder}>
          <div className={classes.brandsListStyle}>
            <div className={classes.mobileBackgroundStyle}>
              <section className={classes.brandsListSection}>
                <div className={classes.brandsListContainer}>
                  <BrandCardsList>
                    {landingBrands.map((brand: any, index: number) => {
                      return (
                        <BrandItem
                          brandLogo={brand.src}
                          name={brand.brandName}
                          cashBack={brand.commission}
                          isCashbackShownInWebsite={
                            brand.isCashbackShownInWebsite
                          }
                          link={generateTrackingLink(
                            brand,
                            {
                              userId: appState.userId,
                              userName: appState.userProfile?.userName,
                            },
                            '',
                            '',
                            Boolean(appState.userId)
                          )}
                          key={index}
                          isCardOnLanding
                        />
                      )
                    })}
                  </BrandCardsList>
                </div>
                <div className={classes.brandsListTitle}>
                  <Typography variant="h2" className={classes.brandsHeading}>
                    {t('home.thousandsOfBrands')}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    className={classes.subtitleBrandsSentence}
                  >
                    {t('home.homeFashionBeauty')}
                  </Typography>
                  <div className={classes.addChirpyestButtonStyle}>
                    <CHROutlinedButton
                      label={'all brands'}
                      font={FONTS.Graphik.GraphikMedium}
                      onClick={() => navigate(ROUTES.brands)}
                      customStyle={classes.allBrands}
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <CHRContentContainer>
          <section className={classes.centerText}>
            <Typography variant="h1" component="h2">
              so what are you waiting for? let’s go!
            </Typography>
            <CHRButton
              onClick={nextStep}
              label="Join chirpyest - it's free"
              customStyle={classes.joinButton}
            />
          </section>
        </CHRContentContainer>
        <MainModal
          openStatus={modalOpened === 1}
          handleClose={handleCloseModal}
          handleFinish={nextStep}
          onIsTermsChecked={handleTermsSwitch}
          onIsNewsletterChecked={handleNewslettersSwitch}
        />
        <JoinWithEmailModal
          openStatus={modalOpened === 2}
          handleClose={handleCloseModal}
          handleFinish={goToUserInfoPage}
          isExtensionDownloaded={isExtensionDownloaded}
          isTermsCheckedParent={isTermsChecked}
          isNewsletterCheckedParent={isNewsletterChecked}
          redirectToLogin={() => {
            handleCloseModal()
            setIsOpenSignInModal(true)
          }}
        />
        <DetailsModal
          openStatus={modalOpened === 3}
          handleClose={handleCloseModal}
          handleFinish={nextStep}
        />
        <PinExtensionReminderPopOut
          open={isModalOpen}
          handleClose={() => setIsModalOpen(false)}
        />
        <SignInModal
          handleClose={closeSignInModal}
          openStatus={isOpenSignInModal}
          setIsLoggedIn={setIsLoggedIn}
        />
      </Layout>
    </>
  )
}

export default withTranslation()(Joins)
